import { render } from "./help.vue?vue&type=template&id=0d398c08"
import script from "./help.js?vue&type=script&lang=js&external"
export * from "./help.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__